import { useMedicareQuoteQuery } from '@coverright/data-access/medicare';
import { useUserProfile } from '../enrollment/use-user-profile';

export const useMedicareQuote = () => {
  const quote = useUserProfile();
  const { data } = useMedicareQuoteQuery({ variables: { id: quote?.quoteId }, skip: !quote?.quoteId });
  return data?.medicareQuote;
};
